import { __assign, __awaiter, __generator } from "tslib";
import { writable } from "svelte/store";
import { ApiClient, pageHandler } from "../GlobalHelper/ApiClient";
var pageStoreHandler = function (pageSelector, campaignStore, storeUpdateFunction) { return __awaiter(void 0, void 0, void 0, function () {
    var client, page_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                client = ApiClient.getInstance();
                if (!client) return [3 /*break*/, 2];
                return [4 /*yield*/, client.campaignClient
                        .listCampaigns(pageHandler(campaignStore.campaigns, pageSelector))
                        .then(function (result) {
                        return result;
                    })["catch"](function (error) {
                        console.log("error", error);
                        return null;
                    })];
            case 1:
                page_1 = _a.sent();
                storeUpdateFunction(function (store) {
                    return __assign(__assign({}, store), { campaigns: page_1 });
                });
                _a.label = 2;
            case 2: return [2 /*return*/];
        }
    });
}); };
function createCampaignStore() {
    var _this = this;
    var _a = writable({
        campaigns: null,
        campaign: null
    }), subscribe = _a.subscribe, set = _a.set, update = _a.update;
    return {
        subscribe: subscribe,
        update: update,
        getFirstPage: function (campaignStore) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, pageStoreHandler("first", campaignStore, update)];
        }); }); },
        getLastPage: function (campaignStore) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, pageStoreHandler("last", campaignStore, update)];
        }); }); },
        getNextPage: function (campaignStore) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, pageStoreHandler("next", campaignStore, update)];
        }); }); },
        getPrevPage: function (campaignStore) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, pageStoreHandler("previous", campaignStore, update)];
        }); }); },
        getSelfPage: function () { },
        getPageNumbered: function (campaignStore, pageNumber) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, pageStoreHandler(pageNumber, campaignStore, update)];
        }); }); },
        setPageSize: function (size) { }
    };
}
export var campaignStore = createCampaignStore();
